import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LuArrowLeft, LuTags } from 'react-icons/lu';
import { useVisitTopicsData } from '../../hooks/useVisitTopicsData.js';
import PageHeader from '../ui/PageHeader';
import Button from '../ui/Button';
import Breadcrumb from './visitTopics/Breadcrumb';
import ClientPostsView from './visitTopics/ClientPostsView';
import ClientsView from './visitTopics/ClientsView';
import { plural } from '../../utils/text.js';

/** Each post analysed by the visit topics job and its visit_topics rows, client by client (admins). */
const VisitTopicsReview = ({ fetchWithAuth }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const clientSlug = searchParams.get('client');
  const selectedKey = searchParams.get('post');
  const clientsState = useVisitTopicsData(fetchWithAuth, '/clients');
  const clients = useMemo(() => clientsState.data ?? [], [clientsState.data]);

  const client = clients.find((c) => c.client_slug === clientSlug);
  const openClient = (slug) => setSearchParams(slug ? { client: slug } : {});
  const openPost = (key) => setSearchParams({ client: clientSlug, post: key });

  return (
    <div className="space-y-4">
      <PageHeader
        icon={LuTags}
        eyebrow="Weekly → DWH"
        title={clientSlug ? (client?.client_name || clientSlug) : 'Topics des visites'}
        subtitle={clientSlug
          ? (client && `${plural(client.posts, 'post traité', 'posts traités')} · ${plural(client.rows, 'ligne')} · ${plural(client.proposals, 'proposition')} · magasins trouvés ${client.stores_found}/${client.visits}`)
          : 'Chaque post analysé par le job de nuit et ses lignes visit_topics, client par client.'}
        actions={clientSlug && <Button variant="secondary" size="sm" icon={LuArrowLeft} onClick={() => openClient(null)}>Tous les clients</Button>}
      />
      {clientSlug && (
        <Breadcrumb items={[
          { label: 'Topics des visites', onClick: () => openClient(null) },
          { label: client?.client_name || clientSlug, onClick: selectedKey ? () => openClient(clientSlug) : null },
          ...(selectedKey ? [{ label: 'Détail du post' }] : []),
        ]} />
      )}
      {clientSlug
        ? <ClientPostsView key={clientSlug} fetchWithAuth={fetchWithAuth} clientSlug={clientSlug} selectedKey={selectedKey} onSelect={openPost} />
        : <ClientsView status={clientsState.status} clients={clients} onOpen={openClient} />}
    </div>
  );
};

export default VisitTopicsReview;
